'use strict';

// utility class
import ApplyClass from '../util/_apply-class';

import TopParallax from '../view/parallax/_top-parallax';
import InterviewParallax from '../view/parallax/_interview-parallax';
import ServiceParallax from '../view/parallax/_service-parallax';
import CompanyParallax from '../view/parallax/_company-parallax';
import RecruitParallax from '../view/parallax/_recruit-parallax';

$(() => {
	// TOP PARALLAX
	$('html.index').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TopParallax, $e, [$e]);
	});
	// interview PARALLAX
	$('html.interview').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(InterviewParallax, $e, [$e]);
	});
	// service PARALLAX
	$('html.service').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ServiceParallax, $e, [$e]);
	});
	// company PARALLAX
	$('html.company').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CompanyParallax, $e, [$e]);
	});
	// recruit PARALLAX
	$('html.recruit').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(RecruitParallax, $e, [$e]);
	});
});